import { HsHypersceneEngineConstants } from '../../constants/hyperscene-engine-constants.global';
import { HsFrustum } from '../../../math-new/shapes/frustum.class';
import { HsMatrix4 } from '../../../math-new/objects/matrix4.class';
import { HsHypersceneConstants } from '../../../math-new/constants/hyperscene-constants.global';
import { HsEngineObject } from '../common/engine-object.class';

export abstract class HsCamera extends HsEngineObject {
  public worldMatrixInverse: HsMatrix4 = HsMatrix4.makeIdentityMatrix();
  public worldMatrixInverseWithZeroPosition: HsMatrix4 = HsMatrix4.makeIdentityMatrix();
  public projectionMatrix: HsMatrix4 = HsMatrix4.makeIdentityMatrix();
  public projectionMatrixInverse: HsMatrix4 = HsMatrix4.makeIdentityMatrix();

  public near: number = HsHypersceneEngineConstants.NEAR_PLANE;
  public far: number = HsHypersceneEngineConstants.FAR_PLANE;
  public readonly frustum: HsFrustum = new HsFrustum();

  static readonly #matrix4Temp1: HsMatrix4 = HsMatrix4.makeIdentityMatrix();

  /**
   * Handles projection matrix.
   */
  protected abstract calculateProjectionMatrix(): void;

  /**
   * Updates world matrix.
   * @returns Result value.
   */
  public updateWorldMatrix(): HsCamera {
    super.updateWorldMatrix();
    return this.updateCameraMatrixInverse();
  }

  /**
   * Updates camera matrix inverse.
   * @returns Result value.
   */
  public updateCameraMatrixInverse(): HsCamera {
    this.worldMatrixInverse.copy(this.worldMatrix).inverse();
    this.worldMatrixInverseWithZeroPosition
      .copy(this.worldMatrix)
      .setPosition(HsHypersceneConstants.ZERO_VECTOR3.values)
      .inverse();
    return this;
  }

  /**
   * Updates projection matrix.
   * @returns Result value.
   */
  public updateProjectionMatrix(): HsCamera {
    this.calculateProjectionMatrix();
    this.projectionMatrixInverse.copy(this.projectionMatrix).inverse();
    return this.updateFrustum();
  }

  /**
   * Updates frustum.
   * @returns Result value.
   */
  public updateFrustum(): HsCamera {
    HsCamera.#matrix4Temp1.copy(this.worldMatrix).inverse();
    HsCamera.#matrix4Temp1.premultiply(this.projectionMatrix);
    this.frustum.setFromProjectionMatrix(HsCamera.#matrix4Temp1);
    return this;
  }
}
